import { render, staticRenderFns } from "./dailyTreatment.vue?vue&type=template&id=c983b55c&"
import script from "./dailyTreatment.vue?vue&type=script&lang=js&"
export * from "./dailyTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports